import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LOG_METHODS } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-log-methods',
  templateUrl: './log-methods.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogMethodsComponent {
  @Input() data: LOG_METHODS;
  public LOG_METHODS_COLORS = {
    [LOG_METHODS.POST]: 'yellow',
    [LOG_METHODS.GET]: 'green',
    [LOG_METHODS.PUT]: 'blue',
    [LOG_METHODS.DELETE]: 'red',
  };
}
